export class CheckAndOpenModalConfirm {
    constructor(optionalOptions = {}) {
        this._modalButton = document.querySelector('.registration-form--more span');

        if (!this._modalButton) {
            this.destructor();
            return true;
        }

        let form
        let inputs
        let isValid = true

        this._modalButton.addEventListener("click", (e) => {
            e.preventDefault();

            isValid = true

            form = document.querySelector('.registration-container--form');
            if (!form) {
                return false
            }

            inputs = form.querySelectorAll('.form-require');
            if (!inputs) {
                return false
            }

            isValid = window.checkEmptyInputs(inputs)

            if (!isValid) {
                return false
            }

            document.getElementById('modal-confirm-phone').querySelector('[data-type="phone"]').innerHTML = form.querySelector('[name="phone"]').value

            window.showModal('modal-confirm-phone')
        })
    }

    destructor() {
        this._modalButton = null;
    }
}

export default new CheckAndOpenModalConfirm();